<div #assetManagerElement></div>
